import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import MobileHeader from './MobileHeader';
import MobileMenu from './MobileMenu';
import Footer from './Footer';
import NewsletterSignup from './NewsletterSignup';
import SEO from './SEO';
import { getAccessToken, getRefreshToken, removeTokens, setAccessToken } from '../api/authUtils';
import { jwtDecode } from 'jwt-decode';
import apiClient from '../api/apiClient';
import './styles/NewsletterPage.css';

const NewsletterPage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const accessToken = getAccessToken();
      const refreshToken = getRefreshToken();

      if (accessToken) {
        try {
          const decodedAccessToken = jwtDecode(accessToken);
          const currentTime = Date.now() / 1000;

          if (decodedAccessToken.exp && decodedAccessToken.exp > currentTime) {
            setIsLoggedIn(true);
          } else if (refreshToken) {
            try {
              const response = await apiClient.post('/accounts/token/refresh/', {
                refresh: refreshToken,
              });

              if (response.status === 200) {
                const data = response.data;
                setAccessToken(data.access);
                setIsLoggedIn(true);
              } else {
                removeTokens();
                setIsLoggedIn(false);
              }
            } catch (error) {
              console.error('Errore durante il refresh del token:', error);
              removeTokens();
              setIsLoggedIn(false);
            }
          } else {
            removeTokens();
            setIsLoggedIn(false);
          }
        } catch (error) {
          console.error('Errore durante la decodifica del token di accesso:', error);
          removeTokens();
          setIsLoggedIn(false);
        }
      } else if (refreshToken) {
        try {
          const response = await apiClient.post('/accounts/token/refresh/', {
            refresh: refreshToken,
          });

          if (response.status === 200) {
            const data = response.data;
            setAccessToken(data.access);
            setIsLoggedIn(true);
          } else {
            removeTokens();
            setIsLoggedIn(false);
          }
        } catch (error) {
          console.error('Errore durante il refresh del token:', error);
          removeTokens();
          setIsLoggedIn(false);
        }
      } else {
        setIsLoggedIn(false);
      }
    };

    checkAuthStatus();
  }, []);

  const pageVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 } },
  };

  return (
    <div className="iscrizione-pagina">
      <SEO 
        title="Iscriviti alla Newsletter di Minerva - Risorse Didattiche e Aggiornamenti"
        description="Iscriviti alla newsletter di Minerva Education AI per ricevere aggiornamenti, risorse didattiche gratuite e suggerimenti su come utilizzare l'intelligenza artificiale nella didattica."
        keywords="newsletter scuola, risorse didattiche, intelligenza artificiale educazione, insegnamento digitale, minerva education"
        ogType="website"
        ogUrl="https://minervaeducationai.it/newsletter"
        canonical="https://minervaeducationai.it/newsletter"
      />
      
      <Header
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />

      <MobileHeader 
        isLoggedIn={isLoggedIn} 
        setMobileMenuOpen={setMobileMenuOpen} 
      />

      {mobileMenuOpen && (
        <MobileMenu
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          setMobileMenuOpen={setMobileMenuOpen}
        />
      )}

      <motion.div 
        className="contenitore"
        initial="hidden"
        animate="visible"
        variants={pageVariants}
      >
        <main className="iscrizione-principale">
          <motion.div 
            className="iscrizione-contenuto"
            variants={contentVariants}
          >
            <div className="iscrizione-intestazione">
              <h1>Unisciti alla Community di Minerva</h1>
              <div className="iscrizione-separatore"></div>
            </div>
            
            <div className="iscrizione-descrizione">
              <p>
                Iscriviti alla nostra newsletter per ricevere:
              </p>
              <ul className="iscrizione-vantaggi-lista">
                <li>
                  <span className="vantaggio-icona">🎓</span>
                  <span className="vantaggio-testo">Risorse didattiche esclusive e pronte all'uso</span>
                </li>
                <li>
                  <span className="vantaggio-icona">💡</span>
                  <span className="vantaggio-testo">Consigli e strategie per innovare la tua didattica</span>
                </li>
                <li>
                  <span className="vantaggio-icona">🚀</span>
                  <span className="vantaggio-testo">Aggiornamenti sulle nuove funzionalità di Minerva</span>
                </li>
                <li>
                  <span className="vantaggio-icona">🔔</span>
                  <span className="vantaggio-testo">Inviti a eventi e webinar formativi gratuiti</span>
                </li>
              </ul>
              
              <p className="nota-privacy">
                Rispettiamo la tua privacy. Non condivideremo mai il tuo indirizzo email e potrai annullare l'iscrizione in qualsiasi momento.
              </p>
            </div>
            
            <div className="iscrizione-modulo">
              <div className="modulo-contenitore">
                <h2>Iscriviti ora</h2>
                <NewsletterSignup />
              </div>
            </div>
          </motion.div>
        </main>
      </motion.div>

      <Footer />
    </div>
  );
};

export default NewsletterPage; 